import './LandingPage.scss'
import React from 'react'
import Hero from '../../components/Hero/Hero'
import Services from '../../components/Services/Services'
import Approach from '../../components/Approach/Approach'
import Showcase from '../../components/Showcase/Showcase'
import Avis from '../../components/Avis/Avis'
import Audiences from '../../components/Audiences/Audiences'
import BackOffice from '../../components/BackOffice/BackOffice'
import Process from '../../components/Process/Process'
import About from '../../components/About/About'
import Contact from '../../components/Contact/Contact'
import Scrollytelling from '../../components/Scrollytelling/Scrollytelling'
import useMediaQuery from '../../utils/useMediaQuery'

// Wide screens: one panel per section.
const desktopPanels = [
    { id: 'hero', scene: 'hero', label: 'Accueil', theme: 'white', node: <Hero /> },
    { id: 'services', scene: 'services', label: 'Comment je peux vous aider', theme: 'grey', node: <Services /> },
    { id: 'approche', scene: 'approche', label: 'Approche', theme: 'white', node: <Approach /> },
    { id: 'realisations', scene: 'realisations', label: 'Réalisations', theme: 'ink', node: <Showcase /> },
    { id: 'back-office', scene: 'back-office', label: 'Du site vitrine à l’outil de gestion', theme: 'white', node: <BackOffice /> },
    { id: 'process', scene: 'process', label: 'Collaboration', theme: 'grey', node: <Process /> },
    { id: 'audiences', scene: 'audiences', label: 'Votre activité, votre site', theme: 'white', node: <Audiences /> },
    { id: 'avis', scene: 'avis', label: 'Avis', theme: 'grey', node: <Avis /> },
    { id: 'about', scene: 'about', label: 'Qui je suis', theme: 'white', node: <About /> },
    { id: 'contact', scene: 'contact', label: 'Contact', theme: 'ink', node: <Contact /> },
]

// Tablets and phones: dense sections are split over several screens.
const compactPanels = [
    { id: 'hero', scene: 'hero', label: 'Accueil', theme: 'white', node: <Hero /> },
    { id: 'services-1', scene: 'services', label: 'Sites vitrines & boutiques', theme: 'grey', node: <Services only={0} /> },
    { id: 'services-2', scene: 'services', label: 'ERP & outils de gestion', theme: 'grey', node: <Services only={1} headerMode="eyebrow" /> },
    { id: 'services-3', scene: 'services', label: 'Diagnostic & architecture', theme: 'grey', node: <Services only={2} headerMode="eyebrow" /> },
    { id: 'approche-1', scene: 'approche', label: 'Architecture & intégration', theme: 'white', node: <Approach only={0} /> },
    { id: 'approche-2', scene: 'approche', label: 'Interface & expérience', theme: 'white', node: <Approach only={1} /> },
    { id: 'realisations', scene: 'realisations', label: 'Réalisations', theme: 'ink', node: <Showcase /> },
    { id: 'back-office-1', scene: 'back-office', label: 'Du site vitrine à l’outil de gestion', theme: 'white', node: <BackOffice part="intro" /> },
    { id: 'back-office-2', scene: 'back-office', label: 'Ce que ça change', theme: 'white', node: <BackOffice part="list" /> },
    { id: 'process-1', scene: 'process', label: 'Collaboration (1/2)', theme: 'grey', node: <Process from={0} to={3} /> },
    { id: 'process-2', scene: 'process', label: 'Collaboration (2/2)', theme: 'grey', node: <Process from={3} to={5} headerMode="eyebrow" /> },
    { id: 'audiences-1', scene: 'audiences', label: 'Votre activité, votre site', theme: 'white', node: <Audiences part="intro" /> },
    { id: 'audiences-2', scene: 'audiences', label: 'Les activités accompagnées', theme: 'white', node: <Audiences part="list" /> },
    { id: 'avis', scene: 'avis', label: 'Avis', theme: 'grey', node: <Avis /> },
    { id: 'about', scene: 'about', label: 'Qui je suis', theme: 'white', node: <About /> },
    { id: 'contact', scene: 'contact', label: 'Contact', theme: 'ink', node: <Contact /> },
]

function LandingPage() {
    const compact = useMediaQuery('(max-width: 1024px)')

    return (
        <div>
            <main>
                <Scrollytelling
                    key={compact ? 'compact' : 'wide'}
                    panels={compact ? compactPanels : desktopPanels}
                />
            </main>
        </div>
    )
}

export default LandingPage
